import React, { useState } from 'react';
import "../../styles/components-styles/question-components-styles/RecentSessions.css";

const RecentSessions = () => {
  const [sessions, setSessions] = useState([
    {
      id: 1,
      type: 'REVISION SET',
      name: 'Immunisation schedule',
      tag: 'Non-diagnosis',
      status: 'Previously incorrect',
      time: '2 minutes ago'
    },
    {
      id: 2,
      type: 'STANDARD',
      name: 'All categories',
      status: 'Previously incorrect',
      time: '2 days ago'
    },
    {
      id: 3,
      type: 'STANDARD',
      name: 'Psychiatry',
      status: 'Previously incorrect',
      time: '1 week ago'
    }
  ]);
  
  const [showMore, setShowMore] = useState(false);
  
  const additionalSessions = [
    {
      id: 4,
      type: 'STANDARD',
      name: 'Cardiology',
      status: 'Previously incorrect',
      time: '2 weeks ago'
    },
    {
      id: 5,
      type: 'REVISION SET',
      name: 'Emergency procedures',
      tag: 'Clinical',
      status: 'Previously incorrect',
      time: '3 weeks ago'
    }
  ];
  
  const loadMore = () => {
    setSessions([...sessions, ...additionalSessions]);
    setShowMore(true);
  };

  return (
    <div className="recent-sessions-container">
      <div className="recent-sessions-header">
        RECENT SESSIONS
      </div>
      
      <div className="sessions-list">
        {sessions.map(session => (
          <div key={session.id} className="session-item">
            <div className="session-header">
              <div className="session-type">{session.type}</div>
              <button className="continue-button">
                Continue
                <svg className="arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
            
            <div className="session-name">{session.name}</div>
            
            <div className="session-tags">
              {session.tag && (
                <span className="session-tag">{session.tag}</span>
              )}
              <span className="session-status">{session.status}</span>
            </div>
            
            <div className="session-time">{session.time}</div>
          </div>
        ))}
      </div>
      
      {!showMore && (
        <div className="load-more-container">
          <button 
            onClick={loadMore}
            className="load-more-button"
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default RecentSessions;